






























import { Vue, Component } from 'vue-property-decorator'
import { DictRequest, DictParam, DictFilter } from '@/types'
import { EPLModule } from '../store/eplmodule'
import moment from 'moment'

@Component({ name: 'Messages' })
export default class Messages extends Vue {
  interval = 0
  idx = -1
  page = 1

  async mounted () {
    setTimeout(() => {
      // this.idx = EPLModule.DictIdx('Events')
      EPLModule.dicts.forEach((d, i) => {
        if (d.name === 'Events') this.idx = i
      })
      if (!EPLModule.dicts[this.idx].locked.read) {
        this.checkMessages()
        this.setMessagesTimeout()
      }
    }, 1100)
  }

  beforeDestroy () {
    clearInterval(this.interval)
  }

  private msg (m: any): string {
    if (m.message.includes('#')) return m.message.split('#')[1]
    else return m.message
  }

  private hdr (m: any): string {
    if (m.message.includes('#')) return `${this.correctDate(m.date)} ${m.message.split('#')[0]}`
    else return this.correctDate(m.date)
  }

  get dict () {
    return EPLModule.dicts[this.idx]
  }

  get rowsCount (): number {
    if (EPLModule.dicts[this.idx] === undefined) {
      return 0
    }
    return EPLModule.dicts[this.idx].rowsCount
  }

  get pagesCount (): number | string {
    if (EPLModule.dicts[this.idx] === undefined) {
      return 0
    }
    let pages = Math.trunc(EPLModule.dicts[this.idx].rowsCount / 10 + 1)
    if (pages === 0) pages = 1
    return pages
  }

  private clearMsgs () {
    EPLModule.clearEvents()
  }

  private changePage () {
    this.checkMessages()
  }

  private setMessagesTimeout (): void {
    this.interval = setInterval(() => {
      this.checkMessages()
    }, 60000)
  }

  private checkMessages (): void {
    if (EPLModule.isAuth) {
      if (EPLModule.user.id > 0) {
        if (EPLModule.dicts[this.idx] !== undefined) {
          const p = {} as DictParam
          const filter = [] as Array<DictFilter>
          p.idx = this.idx
          p.noLists = true
          p.request = {} as DictRequest
          p.request.options = {
            page: this.page,
            itemsPerPage: 10,
            sortBy: ['date'],
            sortDesc: [true]
          }
          const f = {} as DictFilter
          f.field = 'recepient'
          f.condition = `${EPLModule.user.id}`
          f.operator = '='
          f.combine = 'AND'
          filter.push(f)
          filter.push({
            field: 'readed',
            condition: 'false',
            operator: '=',
            combine: 'AND'
          })
          p.request.filter = filter
          EPLModule.fetchDictData(p)
        }
      }
    }
  }

  private markRead (item: any) {
    item.readed = true
    EPLModule.saveDictRow({ idx: this.idx, id: item.id })
    EPLModule.dicts[this.idx].rows.splice(
      EPLModule.dicts[this.idx].rows.indexOf(item),
      1
    )
    EPLModule.dicts[this.idx].rowsCount--
  }

  private gotoForm (item: any) {
    this.markRead(item)
    if (this.$router.currentRoute.path !== `/${item.dict}/${item.rowid}`) { this.$router.push(`/${item.dict}/${item.rowid}`) }
  }

  private correctDate (date: number) {
    return moment.unix(date).format('DD.MM.YYYY HH:mm')
  }
}
